<template>
  <div class="register">
    
    <Header class="get-header" zai="true" v-if="!edit" titles="选择标签"></Header>
    <Header class="get-header" v-else titles="选择标签"></Header>
    <div class="register-list">
      <div class="register-tag" v-for="item in data" :key="item.id">
        <div class="resister-tag__header">{{item.name}}</div>
        <div class="resister-tag__list">
          <!-- <div class="resister-tag__eve" :class="tags[0] == i.name ? 'active' : '' || tags[1] == i.name ? 'active' : '' || tags[2] == i.name ? 'active' : ''" @click.prevent.stop="chooes(i.name)" v-for="i in item.child" :key="i.id">{{i.name}}</div> -->
          <div class="resister-tag__eve" :class="tags.indexOf(i.name) != -1? 'active' : ''" @click.prevent.stop="chooes(i.name)" v-for="i in item.child" :key="i.id">{{i.name}}</div>
        </div>
      </div>
    </div>
    <div class="register-footer">
      <div class="register-chooes" @click="good()" v-if="!edit">选好了</div>
      <div class="register-chooes" @click="goodt()" v-else>选好了</div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header'
import { getTag } from '@/api/api/user'

export default {
  components:{
    Header
  },
  data(){
    return {
      data: null,
      nums: 0,
      tags: [],
      edit: false
    }
  }, 
  activated() {
    this.tags = this.$store.state.chotag
    this.nums = 0
    getTag().then(res => {
      if(res.data.httpCode === "200") {
        this.data = res.data.data
      }
    })
  },
  created() {
    getTag().then(res => {
      if(res.data.httpCode === "200") {
        this.data = res.data.data
      }
    })
    this.edit = this.$route.query.edit
    this.tags = this.$store.state.chotag
  },
  methods:{
    good() {
      this.$store.commit('SET_TAG', this.tags)
      this.$router.replace('/bos/perfect')
      console.log(this.tags)
    },
    goodt() {
      this.$store.commit('SET_TAG', this.tags)
      this.$router.go(-1)
      console.log(this.tags)
    },
    chooes(x) {
      if(this.tags.indexOf(x) != -1) {
        this.tags.splice(this.tags.indexOf(x),1)
      } else {
        if(this.tags.length >= 3) return
        this.tags.push(x)
      }
      // var e = event || window.event
      // console.log(e.target)
      // console.log(index, i)
      
      // if(this.data[index].child[i].check === true) {
      //   this.data[index].child[i].check = false
      //   this.nums -= 1
      //   this.tags.splice((this.tags.indexOf(this.data[index].child[i].name)),1)
      // } else if(this.nums >= 3) {
      //   return
      // } else if (!this.data[index].child[i].check) {
      //   this.data[index].child[i].check = true
      //   this.nums += 1
      //   this.tags.push(this.data[index].child[i].name)
      //   console.log(this.tags)
      // }
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss">
.register {
  .get-header {
    position: fixed;
    top: 0;
    width: 100%;
  }

  .register-footer {
    position: fixed;
    bottom: 0px;
    width: 100%;
    padding-top: 20px;
    z-index: 99;
    background: white;
    height: 76px;
    display: flex;
    justify-content: center;
    .register-chooes {
      z-index: 100;
      text-align: center;
      line-height: 35px;
      color: white;
      height: 35px;
      width: 80%;
      background: #0286FF;
      border-radius: 23px;
    }
  }

  .register-list {
    padding-top: 59px;
    padding-bottom: 60px;

    .register-tag {
      padding: 0 7px 0 15px;
      font-size: 14px;
      .resister-tag__header {
        line-height: 20px;
        padding: 0 10px;
        color: white;
        background-image: url("../../assets/image/z043.png");
        background-size:95px 20px;
        background-repeat:no-repeat;
        border-bottom: 1px solid #ccc;
        margin-bottom: 15px;
      }

      .resister-tag__list {
        margin-bottom: 30px;
        .resister-tag__eve {
          display: inline-block;
          padding: 0 12px;
          height: 20px;
          margin-bottom: 10px;
          text-align: center;
          line-height: 20px;
          background: #F2F2F4;
          margin-right: 8px;
          color: #979797;
          font-size: 14px;
          border-radius: 7px;
        }
        .active {
          // background-image: url('~@/assets/image/is.png');
          background-color: #ABD7FF;
          color: #000000;
          line-height: 20px;
          background-size:100% 100%;
        }
      }
    }
  }
}
</style>